// extracted by mini-css-extract-plugin
export default {"links":"Links_links__Ehak9","line":"Links_line__n9fPI","title":"Links_title__7YV6O"};